import modal from "bootstrap/js/src/modal";
import './modal.scss';

(function ($) {
  'use strict';

  $(document).ready(function () {
    $('[data-translation="false"] a').on('click', (e) => {
      e.preventDefault();

      $('#notranslation').modal('show');
    });
  });

})(jQuery);
